export default {"src":"/_next/static/media/logo-white-orange.be0d1e5c.svg","height":175,"width":292,"blurWidth":0,"blurHeight":0};